module.exports = __webpack_public_path__ + "static/media/send-files.cc49f458.svg";